<div class="verify-email-container">
  <div class="verify-email-content">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-section">
        <div class="spinner"></div>
        <h2>{{ languageService.getCurrentLanguage() === 'tr' ? 'Doğrulanıyor...' : 'Verifying...' }}</h2>
      </div>
    }

    <!-- Success State -->
    @if (!isLoading && isSuccess) {
      <div class="success-section">
        <div class="success-icon">✓</div>
        <h2>{{ getSuccessMessage() }}</h2>
        <!-- Backend Success Message -->
        @if (hasBackendMessage()) {
          <div class="backend-success-message">
            {{ backendMessage }}
          </div>
        }
        <p class="redirect-message">{{ getRedirectMessage() }}</p>
        <button class="btn-home" (click)="redirectToHome()">
          {{ languageService.getCurrentLanguage() === 'tr' ? 'Anasayfaya Dön' : 'Return to Homepage' }}
        </button>
      </div>
    }

    <!-- Error State -->
    @if (!isLoading && !isSuccess) {
      <div class="error-section">
        <div class="error-icon">✗</div>
        <!-- Backend Error Message -->
        @if (hasBackendMessage()) {
          <div class="backend-error-message">
            {{ backendMessage }}
          </div>
        }
        <p class="error-sub-message">{{ getErrorSubMessage() }}</p>
        <p class="redirect-message">{{ getRedirectMessage() }}</p>
        <button class="btn-home" (click)="redirectToHome()">
          {{ languageService.getCurrentLanguage() === 'tr' ? 'Anasayfaya Dön' : 'Return to Homepage' }}
        </button>
      </div>
    }
  </div>
</div>
